import { useState } from 'react';
import Modal from '../../../../../components/Modal';
import { useDispatch, useSelector } from '../../../../../store/store';
import styles from './style.module.scss';
import { ChevronRightIcon, InviteMemberIcon } from '../../../../../assets/icons';
import { setAddExtraApplicantModal, setExtraServiceDetail, setExtraServicesPaymentModal } from '../../../../../store/workspace/slice';
import DropDown from '../../../../../components/DropDown';
import Button from '../../../../../components/Button';
import { selectProfile } from '../../../../../store/workspace/selectors';

const landingUrl = process.env.REACT_APP_LANDING_URL;

interface ListItem {
    id: number;
    sub: number;
    title: string;
};

const list = [
    {
        id: 1,
        sub: 1,
        title: '50 Applicants'
    },
    {
        id: 2,
        sub: 2,
        title: '100 Applicants'
    },
    {
        id: 3,
        sub: 4,
        title: '200 Applicants'
    },
    {
        id: 4,
        sub: 10,
        title: '500 Applicants'
    },
    {
        id: 5,
        sub: 20,
        title: '1000 Applicants'
    },
    {
        id: 6,
        sub: 0,
        title: '+1000 Applicants'
    },
];

const basePriceList = {
    free_trial: 0,
    standard_monthly: 30,
    standard_annual: 30,
    professional_monthly: 28,
    professional_annual: 28,
};

export default function AddExtraApplicant() {
    const dispatch = useDispatch();
    const profile = useSelector(selectProfile);
    const [selectedItem, setSelectedItem] = useState<ListItem | null>(null);
    const pricePerItem = basePriceList[profile?.planType || 'standard_monthly'];

    const openContactSales = () => {
        window.open(`${landingUrl}/book-demo`, '_blank');
    };

    const submit = () => {
        if (!selectedItem) return;

        dispatch(setExtraServiceDetail({
            type: 'applicant',
            sub: selectedItem.sub,
        }));

        dispatch(setAddExtraApplicantModal(false));
        dispatch(setExtraServicesPaymentModal(true));
    };

    return (
        <Modal
            size='md'
            title='Add applicant'
            icon={<InviteMemberIcon />}
            childClassName={styles.wrapper}
            closeFunc={() => dispatch(setAddExtraApplicantModal(false))}
        >
            <h6>To add more, an additional applicants charge applies.</h6>

            <DropDown
                idKey='id'
                titleKey='title'
                dropDownList={list}
                selectedItem={selectedItem}
                containerClassName={styles.dropdown}
                setItem={setSelectedItem}
            />

            {selectedItem?.id !== 6 && <div className={styles.calc}>
                <h6>${pricePerItem} per 50 applicants</h6>
                <h4>${(selectedItem?.sub || 0) * (pricePerItem)}.00</h4>
            </div>}

            {selectedItem?.id === 6 && <div className={styles.info}>
                <h6>For more than 1000 applicants you should contact sales!</h6>
                <div className={styles.info_link} onClick={openContactSales}>
                    <span>Contact sales</span>
                    <ChevronRightIcon />
                </div>
            </div>}

            <div className={styles.actions}>
                <Button
                    type='Outline-Dark'
                    text='Cancel'
                    className={styles.actions_btn}
                    onClick={() => dispatch(setAddExtraApplicantModal(false))}
                />
                <Button
                    type='Primary'
                    text='Continue'
                    onClick={submit}
                    className={styles.actions_btn}
                    disabled={!selectedItem || selectedItem.id === 6}
                />
            </div>
        </Modal>
    )
}
